import { DriveItemId } from '@/drive/entities/DriveItemId';

export function applyPartialOrder<T extends { id: DriveItemId }>(items: T[], orderedIds: DriveItemId[]): T[] {
  const orderedIdSet = new Set(orderedIds);
  const slotIndexes = items.reduce<number[]>((acc, item, index) => {
    if (orderedIdSet.has(item.id)) {
      acc.push(index);
    }

    return acc;
  }, []);

  if (slotIndexes.length === 0) {
    return items;
  }

  const itemsById = new Map(items.map((item) => [item.id, item]));
  const requestedItems = orderedIds.map((id) => itemsById.get(id)).filter((item): item is T => item !== undefined);

  const result = [...items];

  slotIndexes.forEach((slotIndex, position) => {
    result[slotIndex] = requestedItems[position] ?? items[slotIndex];
  });

  return result;
}
